import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ClockIcon, AcademicCapIcon, CurrencyDollarIcon } from '@heroicons/react/24/outline';

const CourseCard = ({ course, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      className="bg-white dark:bg-slate-800 rounded-2xl border border-slate-200 dark:border-slate-700 shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 overflow-hidden"
    >
      {/* Course Header */}
      <div className={`${course.color} p-6 text-white`}>
        <div className="flex items-center justify-between mb-4">
          <div className="text-4xl">{course.icon}</div>
          <div className="text-right">
            <div className="text-2xl font-bold">{course.price}</div>
            <div className="text-sm opacity-90">per hour</div>
          </div>
        </div>
        <h3 className="text-xl font-bold font-display mb-2">{course.title}</h3>
        <p className="text-sm opacity-90">{course.description}</p>
      </div>

      {/* Course Details */}
      <div className="p-6">
        {/* Duration and Level */}
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center text-gray-600 dark:text-gray-400">
            <ClockIcon className="h-4 w-4 mr-2" />
            <span className="text-sm">{course.duration}</span>
          </div>
          <div className="flex items-center text-gray-600 dark:text-gray-400">
            <AcademicCapIcon className="h-4 w-4 mr-2" />
            <span className="text-sm">{course.level}</span>
          </div>
        </div>

        {/* Topics */}
        <div className="mb-6">
          <h4 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-3">
            What you'll learn:
          </h4>
          <div className="grid grid-cols-2 gap-2">
            {course.topics.map((topic, idx) => (
              <div
                key={idx}
                className="text-xs text-gray-600 dark:text-gray-400 bg-gray-50 dark:bg-gray-700 px-2 py-1 rounded"
              >
                {topic}
              </div>
            ))}
          </div>
        </div>

        {/* Action Buttons */}
        <div className="space-y-2">
          <Link
            to="/booking"
            className="w-full bg-gradient-to-r from-indigo-600 to-cyan-500 text-white py-2.5 px-4 rounded-lg text-sm font-semibold hover:from-indigo-700 hover:to-cyan-600 transition-all duration-200 transform hover:scale-[1.02] flex items-center justify-center"
          >
            <CurrencyDollarIcon className="h-4 w-4 mr-2" />
            Book Session
          </Link>
          <Link
            to={`/courses/${course.slug}`}
            className="w-full border border-slate-300 dark:border-slate-600 text-slate-700 dark:text-slate-300 py-2.5 px-4 rounded-lg text-sm font-semibold hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors duration-200 flex items-center justify-center"
          >
            Learn More
          </Link>
        </div>
      </div>
    </motion.div>
  );
};

export default CourseCard;
